import React from "react";
import { Layout, Spin } from "antd";

import AskMobileBar from "pages/ask/AskMobileBar";
import "pages/ask/askLoading.scss";

const { Content } = Layout;

/**
 * Ask on its way in: one spinner, centred, a step down from the header.
 *
 * Two waits come one after the other on arrival -- the page's code, and then the capabilities
 * call that says whether this reader may ask -- and each used to draw its own spinner in its own
 * place: the first centred and hard up against the header, the second in the top-left corner,
 * where `.ask-page` drops its padding. This is both of them. Imported by the router as well as
 * by the page, so it is in the main bundle and ready before the page's code is, and styled from
 * its own sheet for the same reason: `ask.scss` arrives with the page.
 *
 * On a narrow Ask the global Header is gone, so the compact bar keeps the app menu reachable
 * while this wait is on screen.
 */
export default function AskLoading() {
    return (
        <Content className="ask-loading">
            <AskMobileBar title="Ask" showChats={false} />
            <Spin />
        </Content>
    );
}
